<template>
  <div style="margin: 0px; padding: 0px;">
    <el-container direction="vertical" class="layout-container">
    <HEAD :active="curp"></HEAD>
    <el-main class="el-main-ms">
      <div v-for="(item, idx) in list" :key="idx">
        <div v-if="item.pmark == curp">
          <!--图片层-->
          <main-plugin :img-src="item.imgSrc"></main-plugin>
          <!--视频展示组件-->
          <video-plugin :vd-src="item.mp4Src" :logo-src="item.logoSrc" :content-src="item.contentSrc" :brandtitle-src="item.brandtitleSrc"></video-plugin>
          <!--图片轮番-->
          <div ><img :src="item.imgProSrc" style="width:100%;height: 500px"></div>
          <profile-plugin img-align="right" :img-pro-src="item.imgProSrc1" :pro-text="item.proText"></profile-plugin>
        </div>
      </div>
      <!--联系我们-->
      <contact-plugin></contact-plugin>
    </el-main>
    <FOOT></FOOT>
    </el-container>
  </div>
</template>

<script>
import HEAD from './Head'
import FOOT from './Foot'
import MainPlugin from "@/components/MainPlugin";
import ContactPlugin from "@/components/ContactPlugin";
import ProfilePlugin from "@/components/ProfilePlugin";
/*import CarouselPlugin from "@/components/CarouselPlugin";*/
import VideoPlugin from "@/components/VideoPlugin";
export default {
  name: "Cooperate",
  metaInfo: {
    title: '陌上酒店集团官网', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '陌上酒店品牌：陌上集团创立于2009年，是一家酒店产业链公司。旗下拥有酒管、教育、金融设计、装饰、科技、电商等业态，业务领域涉及酒店投资开发、运营管理等板块。'
    },{
      name: 'description',
      content: '陌上酒店品牌包括：陌上轻雅、陌上轻居、陌上艺宿、陌上轻奢等品牌'
    }]
  },
  data() {
    return {
      curp: '2-1',
      list: [

        {
          pmark: '2-1',
          logoSrc: require('../assets/images/mspp1/2-1.png'),
          imgSrc: require('../assets/images/mspp1/1.png'),
          mp4Src: require("../assets/video/QY.mp4"),
          imgProSrc: require("../assets/images/mspp1/2.png"),
          imgProSrc1: require("../assets/images/mspp1/3.png"),
          brandtitleSrc:"花雅东方 花开陌上",
          contentSrc:"陌上轻雅是陌上酒店集团旗下中高端国潮酒店连锁品牌，定位高端文化名媛客群，以中国传统八雅文化中的“宋花” 文化为题，并与宋词 “婉约派” 四大旗帜之一 “李清照” 的宋词融会贯通。将生活社交空间，东方文化的住空间，穿越千年的 “莳花馆” 社交空间，健康 “市集” 的购空间相互融合，为城市优雅文化名媛打造美好的生活社交空间。",
          proText: '<h2 style="color: rgb(124, 185, 186);">陌上轻雅×李清照（宋）</h2>' +
              '<p>酒店品牌：陌上轻雅酒店</p>' +
              '<p>品牌定位：中高端酒店系列</p>' +
              '<p>客群定位：优雅文化名媛</p>' +
              '<p>客房定价：350-600元/间/夜</p>' +
              '<p>盈利模式：酒店+莳花馆（SPA）+新零售</p>' +
              '<p>产品特色：家风、宋词、茶馆、中医</p>' +
              '<p>运营特色：品三茶、穿汉服、飨国味、赏文创</p>' +
              '<p>单房投资：9-12万元/间（极简、标准、豪华）</p>' +
              '<p>回报年限：3年左右</p>'
        },
        {
          pmark: '2-2',
          logoSrc: require('../assets/images/mspp2/2-2.png'),
          imgSrc: require('../assets/images/mspp2/1.png'),
          mp4Src: require("../assets/video/QJ.mp4"),
          imgProSrc: require("../assets/images/mspp2/2.png"),
          imgProSrc1: require("../assets/images/mspp2/3.png"),
          brandtitleSrc:"酒雅东方 花开陌上",
          contentSrc:"陌上轻居是陌上酒店集团旗下中高端国潮酒店连锁品牌，定位年轻千禧一代主流消费客群，以中国传统八雅文化中的 “宋酒” 文化为题，并与宋词 “婉约派” 四大旗帜之一 “柳永” 的宋词融会贯通。将生活社交空间，东方文化的住空间，宋代茶馆、小酒馆 “花涧里” 的社交空间，健康 “市集” 的购空间，三大空间相互融合，为年轻千禧一代打造 “网红” 生活社交空间。",
          proText: '<h2 style="color: rgb(124, 185, 186);">陌上轻居-柳永(宋)</h2>' +
              '<p>酒店品牌：陌上轻居酒店</p>' +
              '<p>品牌定位：中高端酒店系列</p>' +
              '<p>客群定位：Z世代</p>' +
              '<p>客房定价：260-450元/间/夜</p>' +
              '<p>盈利模式：酒店+酒馆+新零售</p>' +
              '<p>产品特色：家风、宋词、茶馆、中医</p>' +
              '<p>运营特色：品三茶、穿汉服、飨国味、赏文创</p>' +
              '<p>单房投资：6.5-9万元/间（极简、标准、豪华）</p>' +
              '<p>回报年限：3年左右</p>'
        },
        {
          pmark: '2-3',
          logoSrc: require('../assets/images/mspp3/2-3.png'),
          imgSrc: require('../assets/images/mspp3/1.png'),
          mp4Src: require("../assets/video/only.mp4"),
          imgProSrc: require("../assets/images/mspp3/2.png"),
          imgProSrc1: require("../assets/images/mspp3/3.png"),
          brandtitleSrc:"诗雅东方 花开陌上",
          contentSrc:"陌上艺宿是陌上酒店集团旗下奢华国潮酒店连锁品牌，定位高端文化名仕消费客群，以中国传统八雅文化中的 “宋诗” 文化为题，并与宋词 “婉约派” 四大旗帜之一 “晏殊” 的宋词融会贯通。将休闲生活社交空间-东方文化的住空间，穿越千年的 “宋茶馆” 社交空间，健康 “市集” 的购空间相互融合，为城市领袖文化名仕打造隐逸的休闲生活社交空间。",
          proText: '<h2 style="color: rgb(124, 185, 186);">陌上艺宿×晏殊（宋）</h2>' +
              '<p>酒店品牌：陌上轻奢酒店</p>' +
              '<p>品牌定位：高端酒店系列</p>' +
              '<p>客群定位：高端商务文化精英</p>' +
              '<p>客房定价：350-600元/间/夜</p>' +
              '<p>盈利模式：酒店+养生馆+新零售</p>' +
              '<p>产品特色：家风、宋词、茶馆、中医</p>' +
              '<p>运营特色：品三茶、穿汉服、飨国味、赏文创</p>' +
              '<p>单房投资：9-12万元/间（极简、标准、豪华）</p>' +
              '<p>回报年限：3年左右</p>'
        },
        {
          pmark: '2-4',
          logoSrc: require('../assets/images/mspp4/2-4.png'),
          imgSrc: require('../assets/images/mspp4/1.png'),
          mp4Src: require("../assets/video/only.mp4"),
          imgProSrc: require("../assets/images/mspp4/2.png"),
          imgProSrc1: require("../assets/images/mspp4/3.png"),
          brandtitleSrc:"茶雅东方 花开陌上",
          contentSrc:"陌上轻奢是陌上酒店集团旗下高端国潮酒店连锁品牌，定位城市高端商务文化精英客群，以中国传统八雅文化中的 “宋茶” 文化为题，并与宋词 “婉约派” 四大旗帜之一 “李煜” 的宋词融会贯通。将生活社交空间，东方文化的住空间，穿越千年的 “宋茶馆” 社交空间，健康 “市集” 的购空间相互融合，为城市高端文化商务精英打造高品质商务社交空间。",
          proText: '<h2 style="color: rgb(124, 185, 186);">陌上轻奢×李煜（宋）</h2>' +
              '<p>酒店品牌：陌上艺宿酒店</p>' +
              '<p>品牌定位：奢华酒店系列</p>' +
              '<p>客群定位：高端文化名仕</p>' +
              '<p>客房定价：400-1000元/间/夜</p>' +
              '<p>盈利模式：酒店+茶馆+新零售</p>' +
              '<p>产品特色：家风、宋词、茶馆、中医</p>' +
              '<p>运营特色：品三茶、穿汉服、飨国味、赏文创</p>' +
              '<p>单房投资：15-25万元/间（极简、标准、豪华）</p>' +
              '<p>回报年限：3年左右</p>'
        },
      ],

    }
  },
  created() {
    this.curp = this.$route.query.pmark
  },
  watch: {
    $route: function (to) {
      this.curp = to.query.pmark
    }
  },
  components: {
    HEAD,
    FOOT,
    MainPlugin,
    ContactPlugin,
    ProfilePlugin,
    /*CarouselPlugin,*/
    VideoPlugin
  }
}
</script>

<style scoped>

</style>
